import { Field } from "redux-form";
import FormElement from "../../forms/form_element";
import React from "react";
import { CampaignEditorPageFormsWrapper } from "./campaign_editor_helpers";
import { createNumberMask } from "redux-form-input-masks";

const currencyMask = createNumberMask({
  prefix: "$ ",
  decimalPlaces: 2,
  locale: "en-US",

  // CPM is stored as Cents
  multiplier: 100,
});

export let CampaignDetailsEditor = ({ handleSubmit, validationErrors }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={FormElement}
        name="name"
        label="campaign name*"
        type="text"
        placeholder="e.g. Nike's Q1 Campaign"
        validationErrors={validationErrors}
      />
      <Field
        component={FormElement}
        name="brandName"
        label="brand name*"
        type="text"
        placeholder="e.g. Nike"
        validationErrors={validationErrors}
      />
      <Field
        component={FormElement}
        name="productName"
        label="product or service name*"
        type="text"
        placeholder="e.g. Nike Air Max"
        validationErrors={validationErrors}
      />
      <Field
        component={FormElement}
        name="productDescription"
        label="Product Description*"
        componentClass="textarea"
        rows={5}
        placeholder="e.g. Give the creator info on the product or service they’ll be promoting."
        validationErrors={validationErrors}
      />
      <Field
        component={FormElement}
        name="website"
        label="website*"
        type="text"
        placeholder="https://"
        validationErrors={validationErrors}
      />
      <Field
        component={FormElement}
        name="goal"
        placeholder="e.g. Give the creator info on your campaign goals, who you want to reach, and the impression you want to leave."
        label="what do you want to accomplish?*"
        rows={5}
        type="textarea"
        componentClass="textarea"
        validationErrors={validationErrors}
      />
      <label className="redcircle-form-label">What's your total budget?*</label>
      <Field
        component="input"
        type="text"
        className="form-control margin-bottom--small"
        name={"totalBudget"}
        {...currencyMask}
      />
    </form>
  );
};

CampaignDetailsEditor = CampaignEditorPageFormsWrapper(CampaignDetailsEditor);
